<template>
    <b-row class="text-center">
        <b-col
            v-for="(date, index) in getDaysArray()"
            :key="index"
            lg="3"
            md="8"
            sm="12"
            class="cartita"
            @click="selectFecha(date)"
        >
            <b-card>
                <a href="javascript:void(0)" class="target">
                    <div>
                        <span> {{ date.dia_semana }} </span>
                        <span class="text-date"
                            >{{ date.mes }},{{ date.dia_numero }}</span
                        >
                    </div>
                </a>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
import moment from "moment";
export default {
    mounted() {
        var daysList = this.getDaysArray();
        console.log(">>>", daysList);
    },
    methods: {
        selectFecha(item) {
            this.$emit("emitFecha", item.fecha_completa);
        },
        getDaysArray() {
            moment.locale("es", {
                months: "Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre".split(
                    "_"
                ),
                monthsShort: "Enero._Feb._Mar_Abr._May_Jun_Jul._Ago_Sept._Oct._Nov._Dec.".split(
                    "_"
                ),
                weekdays: "Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado".split(
                    "_"
                ),
                weekdaysShort: "Dom._Lun._Mar._Mier._Jue._Vier._Sab.".split(
                    "_"
                ),
                weekdaysMin: "Do_Lu_Ma_Mi_Ju_Vi_Sa".split("_")
            });
            var start = new Date();
            var end = moment(start).add(2, "days");
            for (
                var arr = [], dt = new Date(start);
                dt <= end;
                dt.setDate(dt.getDate() + 1)
            ) {
                var formatDate = moment(new Date(dt)).format("LLLL");
                var completeDate = moment(new Date(dt)).format(
                    "dddd, MMMM D, YYYY"
                );
                var splitDate = formatDate.split(",");
                var splitMes = splitDate[1].split(" ");
                var newDate = {
                    dia_semana: splitDate[0],
                    dia_numero: splitMes[2],
                    mes: splitMes[1].substring(0, 3),
                    fecha_completa: completeDate
                };
                arr.push(newDate);
            }
            return arr;
        }
    }
};
</script>

<style lang="scss">
span.text-date {
    margin: 10px;
    font-size: 1.5rem;
    font-weight: 600;
}
</style>
